export const SUBSCRIPTION_TITLE = 'Udacity Subscription';
export const SUBSCRIPTION_SUBTITLE = 'Access to this program and 500+ others';
export const DEFAULT_OVERLAY_TEXT = 'Unlock a lower price on any plan. Save now!';
